const staysOpenSelector = [
  // Picker lists (Theme, Pricebook, Owner…) portal here; collapsing on their pointerdown destroys the picker before the pick lands (WBS-12295).
  '.cdk-overlay-container',
  '.button-menu-commands',
  '.button-menu-commands-backdrop',
  '.wb-dialog-shell',
  '.wb-dialog-host',
  '.p-dialog',
  '.p-dialog-mask',
  '.p-confirmdialog',
].join(', ');

/**
 * Whether this pointerdown is outside the rail and should collapse an unpinned dock.
 * The note menu and any dialog are portaled off the rail. This listener runs in the
 * capture phase, so counting them as outside closes the floating rail before the click lands.
 * A busy page (an upload in flight) never collapses: that destroys the content doing the work (WBS-12284).
 */
export function pointerDownCollapsesRail(target: EventTarget | null, rail: Node | null, busy = false): boolean {

  if (busy || !(target instanceof Node) || !rail || rail.contains(target)) return false;

  const element = target instanceof Element ? target : target.parentElement;
  if (element?.closest(staysOpenSelector)) return false;

  return true;
}
